"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FormControlContext_1 = __importDefault(require("./FormControlContext"));
function useFormControl() {
    return (0, react_1.useContext)(FormControlContext_1.default);
}
exports.default = useFormControl;
//# sourceMappingURL=useFormControl.js.map